import $ from 'jquery';
import scrollIntoView from 'scroll-into-view';

$('.js-scroll-to').on('click', (event) => {
    event.preventDefault();
    const target = document.querySelector($(event.target).attr('href'));
    if (target) {
        scrollIntoView(target);
    } else {
        throw new Error('Target not found');
    }
});




// WEBPACK FOOTER //
// ./app/scripts/components/scroll-to.js